/**
 * 要素やLocationが指す要素を探します。
 *
 * @param e - 元となる要素など
 * @returns 見つかった要素 / 文字列としての`top` / null
 */
export const getTarget = (
  e: HTMLElement | Location
): HTMLElement | "top" | null => {
  // a要素かLocationだったら hash / それ以外なら href属性値を使う
  const id = (
    e instanceof HTMLAnchorElement || e instanceof Location
      ? e.hash
      : e.getAttribute("href") ?? ""
  )
    // `#` より前は削除
    .replace(/^.*#/, "");

  if (id.length === 0) return null;

  const target = document.getElementById(id);

  // 要素があったらそれを返す
  if (target) return target;

  // #top だった場合は文字列を返す
  if (/^top$/i.test(id)) return "top";

  return null;
};
